export default __webpack_public_path__ + "static/media/fa-cloud-upload.7f68c707.svg";